const styles = {
  container: { maxWidth: 150, textOverflow: 'ellipsis', overflow: 'hidden' },
};

export default styles;
